import React from 'react';

/**
 * fill 을 `currentColor` 로 둔다 — 화살표 버튼이 기본·hover 에서 아이콘 색을 뒤집으므로
 * 파일을 두 벌 두지 않고 부모가 색을 정한다.
 */
const CHEVRON_PATH = {
  left: 'M6.29289 0.292893C6.68342 -0.097631 7.31643 -0.0976311 7.70696 0.292893C8.09748 0.683417 8.09748 1.31643 7.70696 1.70696L2.41399 6.99992L7.70696 12.2929C8.09748 12.6834 8.09748 13.3164 7.70696 13.707C7.31643 14.0975 6.68342 14.0975 6.29289 13.707L0.292893 7.70696C-0.0976307 7.31643 -0.0976313 6.68342 0.292893 6.29289L6.29289 0.292893Z',
  right:
    'M0.292893 0.292893C0.683417 -0.0976314 1.31643 -0.0976305 1.70696 0.292893L7.70696 6.29289C8.09748 6.68342 8.09748 7.31643 7.70696 7.70696L1.70696 13.707C1.31643 14.0975 0.683417 14.0975 0.292893 13.707C-0.0976308 13.3164 -0.0976312 12.6834 0.292893 12.2929L5.58586 6.99992L0.292893 1.70696C-0.0976294 1.31643 -0.0976297 0.683416 0.292893 0.292893Z',
} as const;

export default function ChevronIcon({
  direction,
}: {
  direction: 'left' | 'right';
}) {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d={CHEVRON_PATH[direction]} fill="currentColor" />
    </svg>
  );
}
